<template>
    <BaseSelect
      v-model="modelValue"
      v-bind="$attrs"
      v-on="$listeners"
      :options="CASH_CALL_STATUS_OPTIONS"
      label="Cash Call Status"
      size="sm"
    />
  </template>
  
  <script>
  import { defineComponent, computed } from '@vue/composition-api'
  
  import { CASH_CALL_STATUS_OPTIONS } from '@constants'
  
  import { BaseSelect } from '@components/base'
  
  export default defineComponent({
    name: 'CashCallManagementTableFiltersStatus',
    components: {
      BaseSelect
    },
    props: {
      value: {
        type: String,
        default: 'All'
      }
    },
    emits: ['input'],
    setup(props, { emit }) {
      const modelValue = computed({
        get: () => props.value,
        set: (newValue) => emit('input', newValue)
      })
  
      return {
        CASH_CALL_STATUS_OPTIONS,
  
        modelValue
      }
    }
  })
  </script>
  